<template>
  <div class="p10">
    <hm-content title="首页" class="home-content" v-if="false">
      <div>欢迎您！</div>
      <div class="used mt10" v-if="usedList.length">
        <div class="title">常用菜单</div>
        <div>
          <el-tag
            class="pointer"
            :key="i"
            v-for="(v, i) in usedList"
            @click="goMen(v)"
            >{{ v.title }}</el-tag
          >
        </div>
      </div>
      <div class="table-panel flex flex-between flex-wrap mt20">
        <div class="hm-radio-group flex-1">
          <el-radio-group
            v-model="timeStatus.dayType"
            size="small"
            @change="switchTab"
          >
            <el-radio-button label="yesterday">昨日营销</el-radio-button>
            <el-radio-button label="today">今天营销</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <el-date-picker
            v-model="timeStatus.applyDate"
            type="datetimerange"
            align="right"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始时间段筛选"
            end-placeholder="结束时间段筛选"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            clearable
            @change="filterDate"
          ></el-date-picker>
        </div>
      </div>
      <div class="flex flex-wrap item-center">
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x.png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">销售额</div>
            <div class="titval">
              <span>{{ marketList.saleMoney }}</span
              >元
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(1).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">订单数</div>
            <div class="titval">
              <span>{{ marketList.orderNum }}</span
              >笔
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(2).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">新增会员</div>
            <div class="titval">
              <span>{{ marketList.newMemberNum }}</span
              >位
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(3).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">新增推会员</div>
            <div class="titval">
              <span>{{ marketList.newPushMemberNum }}</span
              >位
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(4).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">新增plus会员</div>
            <div class="titval">
              <span>{{ marketList.newPlusMemberNum }}</span
              >位
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(5).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">分销营销额</div>
            <div class="titval">
              <span>{{ marketList.shareSaleMoney }}</span
              >元
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(6).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">分销订单数</div>
            <div class="titval">
              <span>{{ marketList.shareOrderNum }}</span
              >笔
            </div>
          </div>
        </div>
        <div class="flex flex-wrap boxsss">
          <div class="flex-1 flex item-center">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(7).png"
              alt=""
            />
          </div>
          <div class="flex-1 p10" style="width: 100px">
            <div class="tit flex item-center">产生佣金</div>
            <div class="titval">
              <span>{{ marketList.commissionPrice }}</span
              >元
            </div>
          </div>
        </div>
      </div>

      <div class="mt20">
        <div class="flex flex-wrap">
          <div class="order-staus" style="width: 725px">
            <div class="flex flex-wrap mb10">
              <div
                style="width: 60%; fontweight: 600; color: #222"
                class="ml10"
              >
                订单动态
              </div>
            </div>
            <div class="flex flex-wrap">
              <div
                class="flex flex-wrap boxsss"
                @click="gogogo('ShippingOrderList')"
              >
                <div class="flex-1 flex item-center">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(8).png"
                    alt=""
                  />
                </div>
                <div class="flex-1 p10 pointer" style="width: 100px">
                  <div class="tit flex item-center">待发货订单</div>
                  <div class="titval">
                    <span>{{ dynamicList.payOrderNum }}</span
                    >笔
                  </div>
                </div>
              </div>
              <div
                class="flex flex-wrap boxsss pointer"
                @click="gogogo('AfterSaleList')"
              >
                <div class="flex-1 flex item-center">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(9).png"
                    alt=""
                  />
                </div>
                <div class="flex-1 p10" style="width: 100px">
                  <div class="tit flex item-center">待售后订单</div>
                  <div class="titval">
                    <span>{{ dynamicList.returnOrderNum }}</span
                    >笔
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap boxsss">
                <div class="flex-1 flex item-center">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(10).png"
                    alt=""
                  />
                </div>
                <div class="flex-1 p10" style="width: 100px">
                  <div class="tit flex item-center">待付款订单</div>
                  <div class="titval">
                    <span>{{ dynamicList.createOrderNum }}</span
                    >笔
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1" style="width: 470px">
            <div class="flex flex-wrap mb10">
              <div style="fontweight: 600; color: #222">提现状态</div>
            </div>
            <div class="flex flex-wrap">
              <div
                class="flex flex-wrap boxsss pointer"
                @click="gogogo('ExtractManage')"
                style="width: 330px"
              >
                <div class="flex-1 flex item-center">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(11).png"
                    alt=""
                  />
                </div>
                <div class="flex-1 p10" style="width: 100px">
                  <div class="tit flex item-center">待审核提现</div>
                  <div>
                    <span>单数: </span
                    ><span>{{ dynamicList.totalApplyNum }}</span
                    >单
                  </div>
                  <div class="titval">
                    <div class="total-price">
                      总额:
                      <el-tooltip
                        :content="dynamicList.totalPayGetCashCommission"
                        placement="top"
                      >
                        <span>{{
                          dynamicList.totalPayGetCashCommission
                        }}</span> </el-tooltip
                      >元
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex flex-wrap boxsss pointer"
                @click="gogogo('ExtractManage')"
                style="width: 330px"
              >
                <div class="flex-1 flex item-center">
                  <img
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E7%BB%84%2081%402x(12).png"
                    alt=""
                  />
                </div>
                <div class="flex-1 p10" style="width: 100px">
                  <div class="tit flex item-center">待转账提现</div>
                  <div>
                    <span>单数: </span
                    ><span>{{ dynamicList.totalAgreeNum }}</span
                    >单
                  </div>
                  <div class="titval">
                    <div class="total-price">
                      总额:
                      <el-tooltip
                        :content="dynamicList.totalGetCashCommission"
                        placement="top"
                      >
                        <span>{{
                          dynamicList.totalGetCashCommission
                        }}</span></el-tooltip
                      >元
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap mt20">
        <div class="flex-1">
          <div class="flex flex-between">
            <div class="flex item-center">销售走势</div>
            <div class="flex item-center">
              <el-radio-group
                v-model="useImmediately"
                @change="orderChange"
                size="small"
              >
                <el-radio label="0">订单总额</el-radio>
                <el-radio label="1">订单数量</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-select
                size="small"
                clearable
                v-model="form.dayType"
                placeholder="统计单位"
              >
                <el-option label="月" value="month"> </el-option>
                <el-option label="日" value="day"> </el-option>
              </el-select>
            </div>
          </div>
          <ve-line :data="chartData"></ve-line>
        </div>
        <div class="flex-1">
          <div class="flex flex-between">
            <div class="flex item-center flex-center" style="marginleft: 30px">
              订单比例
            </div>
            <div>
              <el-date-picker
                v-if="form.dayType === 'month'"
                v-model="value1"
                type="monthrange"
                range-separator="至"
                size="small"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>

              <!-- <el-date-picker
              v-if="form.dayType === 'day'"
              v-model="form.startTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              :picker-options="startDatePicker"
              type="datetime"
              size="small"
              :placeholder="dialogStatus == 'view' ? '' : '请输入开始时间'"
            ></el-date-picker>
            <el-date-picker
              v-if="form.dayType === 'day'"
              v-model="form.endTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              size="small"
              default-time="23:59:59"
              :picker-options="endDatePicker"
              :disabled="dialogStatus == 'view'"
              type="datetime"
              :placeholder="dialogStatus == 'view' ? '' : '请输入结束时间'"
            ></el-date-picker> -->
              <el-date-picker
                v-if="form.dayType === 'day'"
                :default-time="['00:00:00', '23:59:59']"
                class="mr10"
                size="small"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="form.date"
                type="daterange"
                range-separator="至"
                start-placeholder="请选择时间段"
                end-placeholder="请选择时间段"
              ></el-date-picker>
              <el-button
                @click="search"
                size="small"
                type="primary"
                class="ml10"
                >查询</el-button
              >
            </div>
          </div>
          <ve-pie :data="chartDatas"></ve-pie>
        </div>
      </div>
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="600px"
      >
        <el-scrollbar
          wrap-class="service-scroll"
          wrap-style="height: 500px; overflow-x:hidden"
          :native="false"
        >
          <div class="ql-container">
            <div class="ql-editor" v-html="content"></div>
          </div>
        </el-scrollbar>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small" type="primary"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </hm-content>

    <div class="bg used-menu flex item-center mb10">
      <div class="title">常用菜单</div>
      <div class="flex flex-wrap">
        <el-tag
          class="pointer"
          :key="i"
          v-for="(v, i) in usedList"
          @click="goMen(v)"
          >{{ v.title }}</el-tag
        >
      </div>
    </div>
    <div v-if="isBtn('homeStyle:false')">
      <div class="flex mb10">
        <div class="flex-1 p10 used bg mr10">
          <div class="title">订单动态</div>
          <div class="flex">
            <div
              @click="goOrderRouter(v.toRouter, v.type)"
              class="flex-1 flex box pointer"
              :style="{ background: v.background }"
              v-for="(v, i) in orderList"
              :key="i"
            >
              <div class="picture flex flex-center item-center mr10">
                <el-image style="width: 100%" :src="v.img"></el-image>
                <!-- <span v-else class="hmicon" :style="{color:v.background}" :class="v.icon"></span> -->
              </div>
              <div
                class="flex-1"
                style="line-height: 30px; white-space: nowrap"
              >
                <div>
                  {{ v.title }}
                </div>
                <div>
                  <span class="fw">{{ v.value }}</span>
                  <span class="unit-size">{{ v.unit }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 p10 used bg">
          <div class="title">提现动态</div>
          <div class="flex">
            <div
              @click="goOrderRouter(v.toRouter, v.type)"
              class="pointer flex-1 flex box"
              :style="{ background: v.background }"
              v-for="(v, i) in withdrawalList"
              :key="i"
            >
              <div class="picture flex flex-center item-center mr10">
                <el-image style="width: 100%" :src="v.img"></el-image>
                <!-- <span class="hmicon" :style="{color:v.background}" :class="v.icon"></span> -->
              </div>
              <div class="flex-1" style="line-height: 30px">
                <div>
                  {{ v.title }}
                </div>
                <div>
                  <span class="fw">{{ v.num }} </span
                  ><span class="unit-size">单</span>
                  <el-divider direction="vertical"></el-divider>
                  <span class="unit-size">￥</span
                  ><span class="fw">{{ v.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg p10 mb10">
        <div class="flex flex-between mb20">
          <el-radio-group
            v-model="timeStatus.dayType"
            size="small"
            @change="switchTab"
          >
            <el-radio-button label="yesterday">昨日营销</el-radio-button>
            <el-radio-button label="today">今天营销</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-model="timeStatus.applyDate"
            type="datetimerange"
            align="right"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始时间段筛选"
            end-placeholder="结束时间段筛选"
            value-format="yyyy-MM-dd HH:mm:ss"
            size="small"
            class="mr10"
            clearable
            @change="filterDate"
          ></el-date-picker>
        </div>
        <div class="flex">
          <div
            @click="goRouter(v.toRouter, v.title)"
            style="line-height: 30px"
            class="divder pointer flex-1 flex flex-center"
            v-for="(v, i) in marketingData"
            :key="i"
          >
            <div>
              <div class="flex item-center" style="white-space: nowrap">
                <el-image
                  v-if="v.title === '新增PLUS会员'"
                  style="width: 33px; height: 17px; margin-right: 5px"
                  :src="v.img"
                ></el-image>
                <el-image
                  v-else
                  style="width: 17px; height: 17px; margin-right: 5px"
                  :src="v.img"
                ></el-image>
                <!-- <span  class="hmicon primary" :class="v.icon"></span> -->
                <span>{{ v.title }}</span>
              </div>
              <div>
                <span class="unit-size" v-if="v.unitLocation === 'before'">{{
                  v.unit
                }}</span>
                <span class="fw">{{ v.value }}</span>
                <span class="unit-size" v-if="v.unitLocation === 'after'">{{
                  v.unit
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg p10">
        <div class="used flex flex-between item-center mb20">
          <div class="title" style="margin-bottom: 0px">订单分析图</div>
          <div>
            <el-select
              size="small"
              clearable
              class="mr10"
              v-model="form.dayType"
              placeholder="统计单位"
            >
              <el-option label="月" value="month"> </el-option>
              <el-option label="日" value="day"> </el-option>
            </el-select>
            <el-date-picker
              v-if="form.dayType === 'month'"
              v-model="value1"
              type="monthrange"
              range-separator="至"
              size="small"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
            <el-date-picker
              v-if="form.dayType === 'day'"
              :default-time="['00:00:00', '23:59:59']"
              class="mr10"
              size="small"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="form.date"
              type="daterange"
              range-separator="至"
              start-placeholder="请选择时间段"
              end-placeholder="请选择时间段"
            ></el-date-picker>
            <el-button @click="search" size="small" type="primary" class="ml10"
              >查询</el-button
            >
          </div>
        </div>
        <div class="flex">
          <div class="bg mr10" style="width: 50%">
            <div class="mb10">销售走势</div>
            <div class="flex flex-between item-center mb10">
              <el-radio-group
                v-model="useImmediately"
                @change="orderChange"
                size="small"
              >
                <el-radio label="0">订单总额</el-radio>
                <el-radio label="1">订单数量</el-radio>
              </el-radio-group>
            </div>
            <div>
              <ve-line :data="chartData"></ve-line>
            </div>
          </div>
          <div class="bg" style="width: 50%">
            <div class="mb10">订单比例</div>
            <!-- <div class="flex flex-end mb10">
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form.date"
            type="daterange"
            range-separator="至"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
          ></el-date-picker>
        </div> -->
            <div style="margin-top: 40px">
              <ve-pie :data="chartDatas"></ve-pie>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { ToFixed } from "@/utils/utils";
import moment from "moment";
import { mapGetters } from "vuex";
import VeLine from "v-charts/lib/line.common";
import VePie from "v-charts/lib/pie.common";
export default {
  components: {
    VeLine,
    VePie,
  },
  name: "home",
  data() {
    return {
      orderList: [
        {
          icon: "icon-fugoudingdanshu1",
          title: "待发货订单",
          value: "0",
          unit: "笔",
          background: "#547DFF",
          toRouter: "ShippingOrderList",
          type: "daifahuo",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E5%8F%91%E8%B4%A7%402x.png",
        },
        {
          icon: "icon-fugoudingdanshu1",
          title: "待售后订单",
          value: "0",
          unit: "笔",
          background: "#F65E6A",
          toRouter: "AfterSaleList",
          type: "1",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E5%94%AE%E5%90%8E%402x.png",
        },
        {
          icon: "icon-fugoudingdanshu1",
          title: "待付款订单",
          value: "0",
          unit: "笔",
          background: "#F78752",
          toRouter: "OrderListNew",
          type: "createOrder",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E4%BB%98%E6%AC%BE%402x.png",
        },
      ],
      withdrawalList: [
        {
          icon: "icon-fugoudingdanshu1",
          title: "待审核提现",
          num: "0",
          price: "0.00",
          background: "#BF6DFF",
          toRouter: "ExtractManage",
          type: "apply",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E5%AE%A1%E6%A0%B8%402x.png",
        },
        {
          icon: "icon-fugoudingdanshu1",
          title: "待转账提现",
          num: "0",
          price: "0.00",
          background: "#56B0FF",
          toRouter: "ExtractManage",
          type: "agree",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%85%E8%BD%AC%E8%B4%A6%402x.png",
        },
      ],
      marketingData: [
        {
          icon: "icon-daogouzhushouguanli",
          title: "销售额",
          value: "0",
          unit: "￥",
          unitLocation: "before",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E9%94%80%E5%94%AE%E9%A2%9D%402x.png",
          toRouter: "OrderListNew",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "订单数",
          value: "0",
          unit: "笔",
          unitLocation: "after",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E8%AE%A2%E5%8D%95%402x.png",
          toRouter: "OrderListNew",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "新增会员",
          value: "0",
          unit: "位",
          unitLocation: "after",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E6%96%B0%E5%A2%9E%E4%BC%9A%E5%91%98%402x.png",
          toRouter: "MemberMgt",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "新增推会员",
          value: "0",
          unit: "位",
          unitLocation: "after",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E6%96%B0%E5%A2%9E%E6%8E%A8%E4%BC%9A%E5%91%98%402x.png",
          toRouter: "MemberMgt",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "新增PLUS会员",
          value: "0",
          unit: "位",
          unitLocation: "after",
          img: "https://imgcdn.hemiao100.com/ThemePictures/PLUS%402x.png",
          toRouter: "PlusMemberList",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "分销营销额",
          value: "0",
          unit: "￥",
          unitLocation: "before",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%88%86%E9%94%80%E8%90%A5%E4%B8%9A%E9%A2%9D%402x.png",
          toRouter: "CommissionLaundrylist",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "分销订单数",
          value: "0",
          unit: "笔",
          unitLocation: "after",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E5%88%86%E9%94%80%E8%AE%A2%E5%8D%95%402x.png",
          toRouter: "CommissionLaundrylist",
        },
        {
          icon: "icon-daogouzhushouguanli",
          title: "产生佣金",
          value: "0",
          unit: "￥",
          unitLocation: "before",
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E4%BA%A7%E7%94%9F%E4%BD%A3%E9%87%91%402x.png",
          toRouter: "CommissionLaundrylist",
        },
      ],
      selectDate: "",
      //日期选择范围在一个月内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      value1: "",
      useImmediately: "0",
      timeType: "",
      dialogStatus: "vie2w",
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      startMonthPicker: this.beginMonth(),
      endMonthPicker: this.processMonth(),
      form: {
        date: [],
        startTime: "",
        startMonth: "",
        endMonth: "",
        startDate: "",
        endDate: "",
        dayType: "day",
      },
      chartData: {
        columns: ["dateValue", "分销订单", "非分销订单"],
        rows: [
          // { dateValue: "2019-1月1日", 非分销订单: 123, 分销订单: 123 },
          // { 日期: "1月2日", 非分销订单: 1223, 分销订单: 123 },
          // { 日期: "1月3日", 非分销订单: 2123, 分销订单: 1223 },
          // { 日期: "1月4日", 非分销订单: 4123, 分销订单: 123 },
          // { 日期: "1月5日", 非分销订单: 3123, 分销订单: 123 },
          // { 日期: "1月6日", 非分销订单: 7123, 分销订单: 123 }
        ],
      },
      chartDatas: {
        columns: ["key", "value"],
        rows: [
          // { key: "非分销订单", value: 100 },
          // { key: "分销订单", value: 2100 }
        ],
      },
      isAdmin: false,
      dialogVisible: false,
      title: "",
      content: "",
      timeStatus: {
        applyDate: [],
        dayType: "today",
      },
      usedList: [],
    };
  },
  created() {
    // this.checkShowNotice();
    if (this.isBtn("homeStyle:false")) {
      console.log('未配置权限，发送全部请求')
      this.queryMarketList();
      this.queryDynamicList();
      this.queryAnalysisList();
    }
    this.queryUsedList();
  },
  computed: mapGetters(["marketList", "dynamicList", "analysisList"]),
  methods: {
    goOrderRouter(router, type) {
      this.$router.push({
        name: router,
        query: {
          type,
        },
      });
    },
    goRouter(router, timeType) {
      if (router) {
        if (timeType) {
          let time = [];
          switch (this.timeStatus.dayType) {
            case "yesterday":
              time = [
                moment(new Date()).add(-1, "days").format("YYYY-MM-DD") +
                  " 00:00:00",
                moment(new Date()).add(-1, "days").format("YYYY-MM-DD") +
                  " 23:59:59",
              ];
              break;
            case "today":
              time = [
                moment(new Date()).format("YYYY-MM-DD") + " 00:00:00",
                moment(new Date()).format("YYYY-MM-DD") + " 23:59:59",
              ];
              break;
            default:
              time = this.timeStatus.applyDate;
          }
          let isShareMember = timeType === "新增推会员" ? "yes" : "";

          this.$router.push({
            name: router,
            query: {
              time: JSON.stringify(time),
              isShareMember,
            },
          });
        } else {
          this.$router.push({
            name: router,
          });
        }
      }
    },
    goMen(v) {
      this.$router.push({
        name: v.name,
      });
    },
    async queryUsedList() {
      const { result } = await this.$store.dispatch("queryUsedList", {
        moduleType: "tab",
        funcType: "recentlyUsedTabs",
        pageSize: 10,
        pageNo: 1,
        distinct: "yes",
      });
      const { records } = result;
      if (records.length) {
        records.forEach((v) => {
          v.name = JSON.parse(v.funcId).name;
          v.title = JSON.parse(v.funcId).title;
        });
        this.usedList = records;
      }
    },
    monthChange(val) {},
    monthChanges() {},
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            let day = 31 * 24 * 3600 * 1000;

            let dateRegion = new Date(self.form.startTime).getTime() + day;

            return (
              time.getTime() < new Date(self.form.startTime).getTime() ||
              time.getTime() > dateRegion
            );
          } else {
            return time.getTime(); //开始时间不选时，则不能选择结束事件
          }
        },
      };
    },
    beginMonth() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.endMonth) {
            //如果结束时间不为空，则小于结束时间
            // console.warn(
            //   moment(self.form.startMonth).format("YYYY-MM-01 HH:mm:ss")
            // );
            // return new Date(self.form.endMonth).getTime() < time.getTime();
          } else {
            // console.warn(
            //   moment(self.form.startMonth).format("YYYY-MM-01 HH:mm:ss")
            // );
            // console.warn(self.form.endMonth);
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    processMonth() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.form.startMonth) {
            //如果开始时间不为空，则结束时间大于开始时间
            let day = 12 * 30 * 24 * 3600 * 1000;
            // console.warn(
            //   moment(self.form.startMonth).format("YYYY-MM-01 HH:mm:ss")
            // );

            let dateRegion = new Date(self.form.startTime).getTime() + day;

            return (
              time.getTime() < new Date(self.form.startTime).getTime() ||
              time.getTime() > dateRegion
            );
          } else {
            return time.getTime(); //开始时间不选时，则不能选择结束事件
          }
        },
      };
    },
    async queryMarketList() {
      this.timeStatus.startDate =
        this.timeStatus.applyDate && this.timeStatus.applyDate.length > 0
          ? this.timeStatus.applyDate[0]
          : "";
      this.timeStatus.endDate =
        this.timeStatus.applyDate && this.timeStatus.applyDate.length > 0
          ? this.timeStatus.applyDate[1]
          : "";
      const { code, result } = await this.$store.dispatch(
        "queryMarket",
        this.timeStatus
      );

      if (code === "0") {
        this.marketingData[0].value = ToFixed(result.saleMoney, 2);
        this.marketingData[1].value = result.orderNum;
        this.marketingData[2].value = result.newMemberNum;
        this.marketingData[3].value = result.newPushMemberNum;
        this.marketingData[4].value = result.newPlusMemberNum;
        this.marketingData[5].value = ToFixed(result.shareSaleMoney, 2);
        this.marketingData[6].value = result.shareOrderNum;
        this.marketingData[7].value = ToFixed(result.commissionPrice, 2);
      }
      // return this.$store.dispatch("queryMarket", this.timeStatus);
    },
    async queryDynamicList() {
      const { code, result } = await this.$store.dispatch("queryDynamic");

      if (code === "0") {
        this.orderList[0].value = result.payOrderNum;
        this.orderList[1].value = result.returnOrderNum;
        this.orderList[2].value = result.createOrderNum;
        this.withdrawalList[0].num = result.totalApplyNum;
        this.withdrawalList[0].price = ToFixed(
          result.totalPayGetCashCommission,
          2
        );
        this.withdrawalList[1].num = result.totalAgreeNum;
        this.withdrawalList[1].price = ToFixed(
          result.totalGetCashCommission,
          2
        );
      }
      // return this.$store.dispatch("queryDynamic");
    },
    queryAnalysisList() {
      const searchCondition = JSON.parse(JSON.stringify(this.form));
      searchCondition.startTime =
        this.form.salesDate && this.form.salesDate.length > 0
          ? this.form.salesDate[0]
          : "";
      searchCondition.endTime =
        this.form.salesDate && this.form.salesDate.length > 0
          ? this.form.salesDate[1]
          : "";
      return this.$store
        .dispatch("queryAnalysis", searchCondition)
        .then((res) => {
          res.result.axisInfoList.forEach((v) => {
            if (this.useImmediately === "0") {
              v.非分销订单 = v.orderMoney;
              v.分销订单 = v.shareMoney;
            } else {
              v.非分销订单 = v.orderNum;
              v.分销订单 = v.shareNum;
            }
          });
          if (this.useImmediately === "0") {
            this.chartDatas.rows = res.result.pieMoneyList;
          } else {
            this.chartDatas.rows = res.result.pieNumList;
          }

          this.chartData.rows = res.result.axisInfoList;
        });
    },
    orderChange(val) {
      this.chartData.rows = [];
      this.chartDatas.rows = [];
      if (val === "0") {
        this.chartDatas.rows = this.analysisList.pieMoneyList;
        this.analysisList.axisInfoList.forEach((v) => {
          v.分销订单 = v.shareMoney;
          v.非分销订单 = v.orderMoney;
        });
      } else {
        this.chartDatas.rows = this.analysisList.pieNumList;
        this.analysisList.axisInfoList.forEach((v) => {
          v.分销订单 = v.shareNum;
          v.非分销订单 = v.orderNum;
        });
      }
      this.chartData.rows = this.analysisList.axisInfoList;
      // this.chartData.rows.forEach(v => {
      //   if (val === "0") {
      //     v.非分销订单 = v.orderMoney;
      //     v.分销订单 = v.shareMoney;
      //   } else {
      //     v.非分销订单 = v.orderNum;
      //     v.分销订单 = v.shareNum;
      //   }
      // });
    },

    filterDate(val) {
      if (val) {
        this.timeStatus.dayType = "";
        this.queryMarketList();
      } else {
        this.timeStatus.dayType = "today";
        this.queryMarketList();
      }
    },
    gogogo(val) {
      this.$router.push({
        name: val,
      });
    },
    search() {
      if (this.value1 && this.value1.length > 0) {
        this.form.startDate =
          this.value1 && this.value1.length > 0
            ? moment(this.value1[0]).format("YYYY-MM-01 HH:mm:ss")
            : "";
        this.form.endDate =
          this.value1 && this.value1.length > 0
            ? moment(this.value1[1]).format("YYYY-MM-01 HH:mm:ss")
            : "";
      } else {
        this.form.startDate =
          this.form.date && this.form.date.length > 0 ? this.form.date[0] : "";
        this.form.endDate =
          this.form.date && this.form.date.length > 0 ? this.form.date[1] : "";
      }

      this.queryAnalysisList();
    },
    switchTab() {
      this.timeStatus.applyDate = [];
      this.queryMarketList();
    },
    queryList() {},
    checkShowNotice() {
      // 检测是否从登录界面跳转到本页
      const { from } = this.$route.query;
      if (from === "login") {
        const role = getLoginUser().roles[0];
        if (role === "admin") {
          this.isAdmin = true;
        } else {
          this.$store.dispatch("showNotice").then((res) => {
            const { status, remindType, title, content } = res.result;
            if (status) {
              if (status === 1 && remindType === 0) {
                localStorage.removeItem("invalidDate");
                this.showModal({
                  title,
                  content,
                });
              } else if (status === 1 && remindType === 1) {
                const invalidDate = localStorage.getItem("invalidDate");
                if (!invalidDate) {
                  if (status === 1) {
                    this.showModal({
                      title: title,
                      content,
                    });
                  }
                  localStorage.setItem(
                    "invalidDate",
                    moment().add(1, "days").format("YYYY-MM-DD")
                  );
                }
              }
            }
          });
        }
      }
    },
    showModal({ dialogVisible = true, title, content }) {
      this.dialogVisible = dialogVisible;
      this.content = content;
      this.title = title;
    },
    isBtn(code) {
      console.log("this.code::::", code);
      console.log(this.isShowBtn(code));
      return this.isShowBtn(code);
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.home-container {
  overflow-x: scroll;
}

.home-content {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.used {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.total-price {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 152px;
}
.count {
  strong {
    font-size: 20px;
    color: #e50065;
  }
}
.ml10 {
  margin-left: 10px;
}
.order-list {
  li {
    border: 1px solid #ebeef5;
    font-size: 14px;
    margin-bottom: 10px;
    .order-count {
      text-align: center;
      border-right: 1px solid #ebeef5;
      box-sizing: border-box;
      width: 100px;
    }
    .table-header {
      border-bottom: 1px solid #ebeef5;
      line-height: 23px;
      box-sizing: border-box;
      background: #f5f7fa;
      span {
        padding: 12px 0;
        height: 100%;
        width: 120px;
        text-align: center;
        border-right: 1px solid #ebeef5;
        line-height: 20px;
      }
      span:last-child {
        border-right: 0;
      }
    }
    .order-item {
      > span {
        padding: 12px 0;
        height: 100%;
        width: 120px;
        text-align: center;
        border-right: 1px solid #ebeef5;
      }
      button {
        padding: 0;
      }
      span:last-child {
        border-right: 0;
      }
    }
    .order-item:not(:last-child) {
      border-bottom: 1px solid #ebeef5;
    }
    .order-item:hover {
      background-color: #f5f7fa;
    }
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  padding: 10px;
  // width: 20%;
  // height: 120px;
  // display: inline-block;
  // margin: 0 auto;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  // position: relative;
  img {
    width: 100%;
    // height: 100%;
  }
  .tit {
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    font-family: Microsoft YaHei;
    overflow: hidden;
    white-space: nowrap;
  }
  .titval {
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
  }
  .titvals {
    margin-top: 5px;
    font-size: 18px;
    font-weight: bold;
  }
}

.calendar-out-wrapper {
  margin-right: 2rem;
  margin-bottom: 2rem;
}

.service-scrolll::-webkit-scrollbar-thumb {
  background-color: #808080;
  border-radius: 3px;
}
.boxsss {
  width: 230px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 29px 0px rgba(237, 237, 237, 1);
  border-radius: 6px;
  padding: 8px;
  margin-right: 1%;
  box-sizing: border-box;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .tit {
    font-size: 16px;
    font-weight: 600;
    height: 50%;
  }
  .titval {
    height: 50%;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    span {
      font-size: 23px;
    }
  }
}

.bg {
  background: #fff;
}
.box {
  padding: 10px;
  border-radius: 6px;
  margin-right: 10px;
  color: #fff;

  .picture {
    width: 62px;
    height: 62px;
    background: #ffffff;
    border-radius: 31px;
    .hmicon {
      font-size: 26px;
    }
  }
}

.used-menu {
  .title {
    width: 26px;
    background: #e50065;
    color: #fff;
    font-size: 14px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    padding: 5px 0 5px 5px;
    margin-right: 10px;
  }
}
.divder {
  border-left: 1px solid #eee;
}
.divder:nth-child(1) {
  border-left: none;
}
.fw {
  font-weight: bold;
  font-size: 22px;
}
.unit-size {
  font-size: 12px;
}
</style>
